import { useMemo } from 'react';
import { ContentContainer } from '../../components/common/ContentContainer/contentContainer';
import { Box, Button, Flex, Heading, Spinner, Text } from '@chakra-ui/react';
import { RedirectButton } from 'src/components/common/RedirectButton/redirectButton';
import { useBlockchainProvider } from 'src/providers/Blockchain/blockchainProvider';
import { ACCOUNT_TYPES } from 'src/components/common/Menu/menu';
import { useTranslation } from 'react-i18next';

import { Onboarding } from 'src/components/common/Onboarding/onboarding';
import { InfoSummary } from './InfoSummary/infoSummary';

export const Home = () => {
	const { isLoggedIn, login, isLoading } = useBlockchainProvider();
	const { t } = useTranslation();
	const buttonOptions = {
		[ACCOUNT_TYPES.LOADING]: () => (
			<Spinner
				height="80px"
				width="80px"
			/>
		),
		[ACCOUNT_TYPES.LOGGED]: () => (
			<Flex
				flexDirection={{ base: 'column', md: 'row' }}
				gridGap="20px"
			>
				<RedirectButton
					text={t('pages.homePage.buttons.addGame.header')}
					description={t('pages.homePage.buttons.addGame.description')}
					href="/add"
				/>
				<RedirectButton
					ghost
					text={t('pages.homePage.buttons.gamesList.header')}
					description={t('pages.homePage.buttons.gamesList.description')}
					href="/creator/games"
				/>
			</Flex>
		),
		[ACCOUNT_TYPES.NOT_LOGGED]: () => (
			<Flex gridGap="20px">
				<Button
					variant="sharp"
					onClick={() => login()}
					fontSize="20px"
					h="80px"
				>
					{t('pages.homePage.buttons.connect')}
				</Button>
			</Flex>
		),
	};

	const accountType = useMemo(() => {
		if (isLoading) {
			return ACCOUNT_TYPES.LOADING;
		}

		if (!isLoggedIn) {
			return ACCOUNT_TYPES.NOT_LOGGED;
		}
		return ACCOUNT_TYPES.LOGGED;
	}, [isLoading, isLoggedIn]);

	return (
		<Box>
			<Box>
				<ContentContainer>
					<Flex
						justify="space-between"
						align="center"
						gridGap={{ base: '30px', lg: '15px' }}
						flexDir={{ base: 'column', lg: 'initial' }}
						w="100%"
					>
						<Heading
							maxW="520px"
							fontSize={{ base: '30px', md: '50px' }}
							lineHeight="120%"
							fontWeight="400"
							textAlign={{ base: 'center', lg: 'initial' }}
						>
							{t('mainHeader.info')}
							<Box
								display="inline-block"
								color="#ff3f33"
							>
								{t('mainHeader.manage')}
							</Box>
						</Heading>
						{buttonOptions[accountType]()}
					</Flex>
				</ContentContainer>
				<InfoSummary />
			</Box>
			<ContentContainer>
				<Flex
					flexDirection="column"
					gridGap="50px"
				>
					<Flex
						flexDirection="column"
						gridGap="25px"
						maxW="650px"
					>
						<Heading
							fontSize={{ base: '30px', md: '50px' }}
							lineHeight="140%"
						>
							{t('onboarding.header')}
						</Heading>
						<Text
							fontSize="18px"
							color="#9A9A9A"
						>
							{t('onboarding.description')}
						</Text>
					</Flex>
					<Onboarding />
				</Flex>
			</ContentContainer>
		</Box>
	);
};
